/**
 * GNT Part A.1 partner hierarchy on organizations/{orgId}.
 * Keep in sync with functions/src/organizations/partnerTiers.js
 */
export const PARTNER_TIERS = [
  { value: "none", label: "None" },
  // MKT-05: the stored value stays `founding`. Only the label users see changes.
  { value: "founding", label: "Fusion Founder" },
  { value: "fusion", label: "Fusion Partner" },
  { value: "fusion_affiliate", label: "Fusion Affiliate" },
];

export const PARTNER_TIER_VALUES = PARTNER_TIERS.map((t) => t.value);

export const PARTNER_TIERS_REQUIRING_FOUNDING_PARTNER = new Set([
  "fusion",
  "fusion_affiliate",
]);

export function isValidPartnerTier(value) {
  return PARTNER_TIER_VALUES.includes(value);
}

/** Absent / unknown → "none". */
export function normalizePartnerTier(value) {
  if (typeof value === "string" && PARTNER_TIER_VALUES.includes(value)) {
    return value;
  }
  return "none";
}

export function partnerTierRequiresFoundingPartner(tier) {
  return PARTNER_TIERS_REQUIRING_FOUNDING_PARTNER.has(normalizePartnerTier(tier));
}
